import { GridCellProps } from "@progress/kendo-react-grid";
import { IconDefinition } from "@fortawesome/fontawesome-common-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ButtonProps } from "@mui/material";

type KendoGridCommandCellButtonProps = {
  gridCellProps: GridCellProps;
  faIcon: IconDefinition;
  disabled?: boolean;
  onClick: (gridCellProps: GridCellProps) => void;
};

export const KendoGridCommandCellButton = ({
  gridCellProps,
  faIcon,
  onClick,
  disabled = false,
  ...others
}: KendoGridCommandCellButtonProps & ButtonProps) => {
  return (
    <button
      {...others}
      type="button"
      className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-grid-save-command"
      disabled={disabled}
      onClick={() => onClick(gridCellProps)}
    >
      <FontAwesomeIcon icon={faIcon} />
    </button>
  );
};
